// export const url = 'http://demo-marketin.fidem.am';
// export const urlLink = 'http://demo-marketin.fidem.am';

export const url = "https://api.guavanova.am";
export const urlLink = "https://api.guavanova.am";
